import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Separator } from '@cuemath/comps';
import Select from 'react-select';
import PropTypes from 'prop-types';

const Field = styled.div`
  width: 65%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ profileView }) => `${profileView ? '10px' : '12px'}`};
`;

const Label = styled.label`
  width: 25%;
  display: flex;
  justify-content: left;
`;

const SelectInput = styled(Select)`
  width: 75%;
`;

const KEYS = {
  node_types: 'node_type',
  topics: 'topic',
  grades: 'grade',
  boards: 'board',
  removed: 'removed',
};

const FILTER = {
  BOARDS: 'boards',
  TOPICS: 'topics',
  TYPES: 'node_types',
  GRADES: 'grades',
};

export default class SelectForm extends PureComponent {
  static propTypes = {
    selectedValue: PropTypes.shape({}).isRequired,
    onSelectChange: PropTypes.func.isRequired,
  };

  getCheckOptions = (options, isIdTrue) => {
    let arr = [];

    if (isIdTrue) {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.id };
      });
    } else {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.code };
      });
    }

    return arr;
  };

  getSelectedValue = options => {
    if (!options) return null;
    if (Object.keys(options).length < 1 || options.length < 1) return null;
    return Array.isArray(options) ? options.map(({ value }) => value) : options.value;
  };

  setValue = value => {
    const { selectedValue } = this.props;
    const { choices } = selectedValue;
    let selection =
      choices.length &&
      choices.length > 0 &&
      choices.filter(option => {
        return value && Array.isArray(value)
          ? value.includes(option.value)
          : option.value === value;
      });
    return selection;
  };

  render() {
    const {
      selectedValue,
      value,
      disabled,
      removeValue,
      tag,
      onSelectChange,
    } = this.props;

    const { name, label, multiple } = selectedValue || {};

    if (name === FILTER.GRADES) {
      tag[name].sort((a, b) => (parseInt(a.name, 10) > parseInt(b.name, 10) ? 1 : -1));
    }

    selectedValue.choices = this.getCheckOptions(tag[name], !!tag[name][0].id);

    let addedSelection = this.setValue(value);

    let removedSelection = this.setValue(removeValue);

    if (selectedValue.length && !multiple) addedSelection = addedSelection[0];

    if (name === FILTER.TYPES) {
      return (
        <Field justifyContent>
          <Label>{label}</Label>
          <SelectInput
            value={addedSelection}
            onChange={selected =>
              onSelectChange(`${KEYS[name]}`, this.getSelectedValue(selected))
            }
            isSearchable
            isDisabled={disabled}
            isMulti={!!multiple}
            options={selectedValue.choices}
          />
        </Field>
      );
    }

    return (
      <>
        <Field justifyContent>
          <Label>Add</Label>
          <SelectInput
            value={addedSelection}
            onChange={selected =>
              onSelectChange(`added_${KEYS[name]}_ids`, this.getSelectedValue(selected))
            }
            isSearchable
            isDisabled={disabled}
            isMulti={!!multiple}
            options={selectedValue.choices}
          />
        </Field>
        <Separator height={20} transparent />
        <Field justifyContent>
          <Label>Remove</Label>
          <SelectInput
            value={removedSelection}
            onChange={selected =>
              onSelectChange(`removed_${KEYS[name]}_ids`, this.getSelectedValue(selected))
            }
            isSearchable
            isDisabled={disabled}
            isMulti={!!multiple}
            options={selectedValue.choices}
          />
        </Field>
      </>
    );
  }
}
